import React from "react";
import { Quote } from "lucide-react";

const reviews = [
  {
    name: "Virginia C.",
    age: "daughter of Mary, 96",
    location: "Reading",
    quote:
      "We are so lucky to have found Jakub. Our 96 yr old mum fell and was unable to walk or even stand. After 2 months physio with Jakub she has regained strength and now able to walk around her home with her walker. Jakub has encouraged, supported and challenged her every step of the way. He is continuing to work with her to enable her to stay in her home.",
  },
  {
    name: "Wioletta G.",
    age: 46,
    location: "Sherfield on Loddon",
    quote:
      "I had a great experience with Reading Physio. I've been having physio sessions with Mr. Jakub for a few months. Incredible experience and I am delighted with the recovery progress. I wouldn't hesitate to recommend him or use his services again in future.",
  },
  {
    name: "Valerie S.",
    age: 71,
    location: "Reading",
    quote:
      "Highly recommend. I worked with them after a fall to ensure recovery. They are considerate but understand how to motivate you to keep on working to improve. They are fully aware of all the latest ideas within their profession without forgetting the basics. Can't recommend highly enough.",
  },
  {
    name: "Nora S.",
    age: 22,
    location: "London",
    quote:
      "Excellent knowledge and exercises for every step while recovering from being in a wheelchair. Never thought I'd learn to walk this well again. So grateful, definitely recommend.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-20 md:py-32 px-6 md:px-12 bg-brand-sand"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16">
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-brand-terracotta" data-testid="testimonials-eyebrow">
            In their words
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-brand-blue mt-4 leading-tight" data-testid="testimonials-headline">
            Real stories from real Berkshire residents.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {reviews.map((r, idx) => (
            <figure
              key={r.name}
              className="bg-white rounded-3xl p-7 md:p-8 border border-brand-clay flex flex-col"
              data-testid={`testimonial-card-${idx + 1}`}
            >
              <Quote size={32} strokeWidth={1.5} className="text-brand-terracotta mb-4" />
              <blockquote className="font-display text-lg md:text-xl leading-snug text-slate-800 flex-1">
                &ldquo;{r.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-brand-clay">
                <p className="font-semibold text-brand-blue">{r.name}, {r.age}</p>
                <p className="text-sm text-slate-500">{r.location}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
